import { apiGet, apiPatch, apiPost } from './client';
import type { WahaConnection, WahaConnectionStatus } from '../types';

export function getWahaConnections(): Promise<WahaConnection[]> {
  return apiGet<WahaConnection[]>('/waha/connections');
}

export function createWahaConnection(data: {
  companyId?: string;
  apiBaseUrl: string;
  apiKey: string;
  instanceName: string;
}): Promise<WahaConnection & { postponed: boolean; connectionState?: string }> {
  return apiPost('/waha/connections', data);
}

export function attachWahaConnection(data: {
  companyId?: string;
  apiBaseUrl: string;
  apiKey: string;
  instanceName: string;
}): Promise<WahaConnection & { attached: boolean; connectionState?: string }> {
  return apiPost('/waha/connections/attach', data);
}

export function updateWahaConnection(id: string, data: { isActive?: boolean; apiKey?: string }): Promise<WahaConnection> {
  return apiPatch(`/waha/connections/${id}`, data);
}

export function getWahaStatus(id: string): Promise<WahaConnectionStatus> {
  return apiGet(`/waha/connections/${id}/status`);
}

export function connectWaha(id: string): Promise<{ state: string; qrcode: unknown; raw: unknown }> {
  return apiPost(`/waha/connections/${id}/connect`);
}

export function stopWaha(id: string): Promise<{ state: string; raw: unknown }> {
  return apiPost(`/waha/connections/${id}/stop`);
}

export function syncWahaWebhook(id: string): Promise<{ synced: boolean; webhookUrl: string }> {
  return apiPost(`/waha/connections/${id}/sync-webhook`);
}
